{
  "de": {
    "textExtract": {
      "alerts": {
        "limitReached": "Sie haben Ihr Limit für Textextraktionen erreicht."
      },
      "buttons": {
        "extract": "Text extrahieren",
        "processing": "Verarbeitung läuft..."
      },
      "errors": {
        "processingFailed": "Die Textextraktion ist fehlgeschlagen. Bitte versuchen Sie es erneut."
      },
      "inputKinds": {
        "file": {
          "dropTitle": "Datei hier hineinziehen oder {select}",
          "dropTitleSelect": "auswählen",
          "help": "PDFs, Bilder, Audiodateien und gängige MS-Office-Formate",
          "label": "Datei",
          "maxSize": "Maximal {limit} MB",
          "placeholder": "Datei auswählen",
          "title": "Datei"
        },
        "audio": {
          "help": "Tipp: Du kannst eine Datei per Drag & Drop direkt hochladen. Wir unterstützen .mp3, .mp4, .mp4a oder .wav Dateien bis max. {limit}MB.",
          "icon": "bi-file-music",
          "label": "Audiodatei",
          "placeholder": "Audiodatei auswählen",
          "title": "Audiodatei"
        },
        "image": {
          "help": "Tipp: Du kannst eine Datei per Drag & Drop direkt hochladen. Wir unterstützen .jpeg, .png bis zu {limit}MB.",
          "icon": "bi-image",
          "label": "Bilddatei",
          "placeholder": "Bilddatei auswählen",
          "title": "Bild"
        },
        "pdf": {
          "help": "Tipp: Du kannst eine Datei per Drag & Drop direkt hochladen. Wir unterstützen .pdf bis zu {limit}MB.",
          "icon": "bi-file-earmark-pdf",
          "label": "PDF-Datei",
          "placeholder": "PDF-Datei auswählen",
          "title": "PDF"
        },
        "video": {
          "help": "Tipp: Du kannst eine Datei per Drag & Drop direkt hochladen. Wir unterstützen .mp4, .mp4v, .avi or .mkv Dateien bis max. {limit}MB.",
          "icon": "bi-film",
          "label": "Videodatei",
          "placeholder": "Videodatei auswählen",
          "title": "Video Datei"
        },
        "website": {
          "label": "Webseiten URL",
          "placeholder": "https://fobizz.com/was-ist-fobizz/",
          "title": "Webseite"
        },
        "youtube": {
          "label": "YouTube URL oder Suche",
          "placeholder": "YouTube URL eingeben oder nach Video suchen...",
          "title": "YouTube"
        },
        "text": {
          "label": "Text",
          "placeholder": "Hier kannst du Hintergrundwissen selbst einfügen...",
          "title": "Text"
        }
      },
      "labels": {
        "language": "Sprache"
      },
      "modal": {
        "title": "Text extrahieren"
      },
      "sourcePicker": {
        "addNew": "Neu hinzufügen",
        "recent": "Zuletzt verwendet"
      },
      "upload": {
        "success": "Datei erfolgreich hochgeladen"
      },
      "options": {
        "languages": {
          "auto": "Automatisch erkennen"
        }
      },
      "youtube": {
        "noResults": "Keine Videos für Ihre Suche gefunden.",
        "searchError": "Fehler beim Suchen der Videos. Bitte versuchen Sie es erneut."
      },
      "privacyHint": "Teile keine sensiblen Informationen oder persönlichen Daten von Schüler*innen mit einer KI."
    }
  }
}
